// ============================================
// CONFIGURAÇÃO DO FACEBOOK PIXEL
// ============================================
const PIXEL_ID = '282883704611553';

// Inicializar o Facebook Pixel
export const initFacebookPixel = () => {
  if (typeof window === 'undefined') return;

  // Verificar se o pixel já foi inicializado
  if ((window as any).fbq) return;

  // Código padrão do Facebook Pixel
  (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  (window as any).fbq('init', PIXEL_ID);
  (window as any).fbq('track', 'PageView');
};

// Disparar evento customizado baseado no grau de calvície
export const trackFacebookPixel = (grau_calvicie: string, email: string) => {
  if (typeof window === 'undefined' || !(window as any).fbq) {
    console.warn('Facebook Pixel não inicializado');
    return;
  }

  const eventData = {
    email,
  };

  switch (grau_calvicie) {
    case 'inicial':
      (window as any).fbq('trackCustom', 'CalvicieInicial', eventData);
      console.log('Evento Facebook Pixel disparado: CalvicieInicial', eventData);
      break;
    case 'moderada':
      (window as any).fbq('trackCustom', 'CalvicieModerada', eventData);
      console.log('Evento Facebook Pixel disparado: CalvicieModerada', eventData);
      break;
    case 'avancada':
      (window as any).fbq('trackCustom', 'CalvicieAvancada', eventData);
      console.log('Evento Facebook Pixel disparado: CalvicieAvancada', eventData);
      break;
    default:
      console.warn('Grau de calvície desconhecido:', grau_calvicie);
  }
};
